import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
    <div class="heading01 type01">
        <h1>{{ 'performanceReview.Development plan' | translate }}</h1>
    </div>
    <review-development-plan-filter
        list="vm.list"
        filter="vm.filter"
        default-filter="vm.defaultFilter"
    />
    <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
    <pagination-tools list="vm.list"></pagination-tools>
    <table class="data01">
        <thead>
            <tr>
                <th>{{ 'performanceReviewTraining.Development field' | translate }}</th>
                <th>{{ 'performanceReviewTraining.Actions' | translate }}</th>
                <th>{{ 'performanceReviewTraining.Development deadline' | translate }}</th>
                <th>{{ 'performanceReviewTraining.Employee' | translate }}</th>
                <th>{{ 'performanceReviewTraining.Performance review date' | translate }}</th>
            </tr>
        </thead>
        <tbody>
            <tr ng-repeat="item in vm.list.items">
                <td>{{ item.developmentField }}</td>
                <td>{{ item.action }}</td>
                <td>{{ vm.MomentService.formatDate(item.deadline) }}</td>
                <td>{{ item.review.user.displayName }}</td>
                <td>
                    <a ui-sref="authorized.review.manage({ id: item.review.id })">
                        {{ vm.MomentService.formatTimeStamp(item.review.reviewDate) }}
                    </a>
                </td>
            </tr>
        </tbody>
    </table>
    <pagination list="vm.list"></pagination>
    `
})
export default class {
    constructor (ListFactory, ReviewResource, MomentService) {
        this.ListFactory = ListFactory;
        this.ReviewResource = ReviewResource;
        this.MomentService = MomentService;
    }

    $onInit () {
        this.list = this.ListFactory.createWithPagination(this.ReviewResource.trainingNeeds.bind(this.ReviewResource));
        this.list.pagination.perPage = 25;
        this.defaultFilter = { expand: 'review.user' };
        this.filter = angular.copy(this.defaultFilter);
        this.list.fetch(this.filter);
    }

}



// WEBPACK FOOTER //
// ./src/app/components/review/developmentPlan/index.js